import { CompassRose } from '@brig/theme/ornaments';
import { useTranslation } from 'react-i18next';
import * as styles from './LoadingNotice.css.ts';

/** Polite loading state: a slowly swinging compass card. */
export function LoadingNotice() {
  const { t } = useTranslation();
  return (
    <div className={styles.root} role="status" aria-live="polite">
      <CompassRose size={72} className={styles.rose} northLabel="" ink="#2F2418" paper="#F1E6C8" />
      <p>{t('app.loading')}</p>
    </div>
  );
}
